import ActivityType from "./../entities/activityType";
import WindowType from "./../entities/windowType";
import * as util from "./../helpers/util";
import ActivityManager from "./../core/activityManager";
import My from "./activityMyAPI";
import { WindowDefinition } from "./../entities/windowDefinition";
import { Callback } from "./../contracts/contracts";
import Activity from "./../entities/activity";
import ActivityWindow from "./../entities/activityWindow";
import { ActivityStatus } from "./../contracts/activityStatus";
import { WindowFactory } from "../contracts/windowFactory";
import { Glue42 } from "../../../glue";

export interface ManagementAPI {
  activityTypes: Glue42.Activities.ActivityTypesAPI;
  windowTypes: Glue42.Activities.WindowTypesAPI;
  windows: Glue42.Activities.WindowingAPI;
  instances: Glue42.Activities.InstancesAPI;

  onAttached(callback: () => void): void;
  onDetached(callback: () => void): void;
  onActivityFrameColorChanged(callback: () => void): void;
}

export class ActivityManagementAPI implements ManagementAPI {

  public _m: ActivityManager;

  public _my: My;

  public activityTypes: Glue42.Activities.ActivityTypesAPI;

  public windowTypes: Glue42.Activities.WindowTypesAPI;

  public windows: Glue42.Activities.WindowingAPI;

  public instances: Glue42.Activities.InstancesAPI;

  constructor(manager: ActivityManager, my: My) {
    this._m = manager;
    this._my = my;

    this.activityTypes = {
      get: this._getActivityTypesWrapper.bind(this),
      register: this._m.registerActivityType.bind(this._m),
      unregister: this._m.unregisterActivityType.bind(this._m),
      subscribe: this._m.subscribeActivityTypeEvents.bind(this._m),
      unsubscribe: undefined,
      initiate: this._m.initiate.bind(this._m)
    };

    this.windowTypes = {
      get: this._getWindowTypesWrapper.bind(this),
      registerFactory: this._m.registerWindowFactory.bind(this._m),
      unregisterFactory: this._m.unregisterWindowFactory.bind(this._m),
      subscribe: this._m.subscribeWindowTypeEvents.bind(this._m),
      unsubscribe: undefined
    };

    this.windows = {
      get: this._m.getWindows.bind(this._m),
      subscribe: this._m.subscribeWindowEvents.bind(this._m),
      announce: this._m.announceWindow.bind(this._m),
      unsubscribe: undefined,
      create: this._m.createWindow.bind(this._m)
    };

    this.instances = {
      get: this._m.getActivities.bind(this._m),
      subscribe: this._m.subscribeActivityEvents.bind(this._m),
      unsubscribe: undefined
    };
  }

  public onAttached(callback: () => void) {
    this._m.subscribeActivitiesAttached(callback);
  }

  public onDetached(callback: () => void) {
    this._m.subscribeActivitiesDetached(callback);
  }

  public onActivityFrameColorChanged(callback: () => void) {
    this._m.subscribeActivityFrameColorChanged(callback);
  }

  private _getActivityTypesWrapper(name?: string): ActivityType[] | ActivityType {
    if (util.isUndefined(name)) {
      return this._m.getActivityTypes();
    }
    return this._m.getActivityType(name);
  }

  private _getWindowTypesWrapper(name?: string): WindowType[] | WindowType {
    if (util.isUndefined(name)) {
      return this._m.getWindowTypes();
    }
    return this._m.getWindowType(name);
  }
}
